module.exports = __webpack_public_path__ + "img/bullet.7a8c732d.svg";